import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Cash.scss';
import CashInput from './CashInput';
import { setTriggerRefreshInput, setTriggerSave } from './reducers/CashInputReducer';
import CashTable from './CashTable';
import CashAccountModal from './CashAccountModal';
import CashDetailModal from './CashDetailModal';

let triggerHotkeyAlready = false;

const Cash: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "Cash";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid container className="input-fields">
                    <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                        <CashInput></CashInput>
                    </div>
                </Grid>
                <Grid container className="datatable">
                    <CashTable>
                    </CashTable>
                </Grid>
            </Grid>
            <CashAccountModal></CashAccountModal>
            <CashDetailModal></CashDetailModal>
        </>
    )
};

export default Cash;